import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleAndroidInstall = async () => {
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
      const { outcome } = await window.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        console.log('تم تثبيت التطبيق');
        window.deferredPrompt = null;
      }
    }
  };

  const handleiOSInstall = () => {
    navigate('/ios-install');
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <h1>لوحة التحكم الرئيسية</h1>
        </div>

        <div className="dashboard-main">
          <div className="welcome-section">
            <h2>مرحباً بك في نظام Metro4</h2>
            <p className="user-role">نظام إدارة المعامل - مترو القاهرة الكبرى الخط الرابع</p>
            {user && (
              <>
                <p className="user-role">{user.fullName}</p>
                <p className="user-station">{user.role} - {user.station}</p>
              </>
            )}
          </div>

          <div className="install-section">
            <h3>📱 ثبّت التطبيق على جهازك</h3>
            <div className="install-buttons-grid">
              <button 
                className="install-btn android-btn"
                onClick={handleAndroidInstall}
                title="تثبيت مباشر على Android"
              >
                <div className="btn-icon">🤖</div>
                <div className="btn-text">
                  <span className="btn-title">تثبيت Android</span>
                  <span className="btn-desc">تثبيت فوري</span>
                </div>
              </button>

              <button 
                className="install-btn ios-btn"
                onClick={handleiOSInstall}
                title="شرح تثبيت على iPhone"
              >
                <div className="btn-icon">🍎</div>
                <div className="btn-text">
                  <span className="btn-title">تثبيت iPhone</span>
                  <span className="btn-desc">شرح مفصّل</span>
                </div>
              </button>
            </div>
          </div>

          <div className="project-info">
            <h3>معلومات المشروع</h3>
            <div className="info-grid">
              <div className="info-item">
                <strong>المشروع:</strong>
                <span>GREATER CAIRO METRO Line 4 Phase 1</span>
              </div>
              <div className="info-item">
                <strong>العقد:</strong>
                <span>CONTRACT No. 125 / METRO</span>
              </div>
              <div className="info-item">
                <strong>الشركة:</strong>
                <span>ORASCOM CONSTRUCTION</span>
              </div>
              <div className="info-item">
                <strong>الاستشاري:</strong>
                <span>NOCE Engineering Consultants</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;